export const apiBaseUrl = 'https://app.audienceanywhere.com/api';
 export const optimizeApiBaseUrl = 'https://api-optimize.audienceanywhere.com';
export const uiBuildNumber =   2595638486



// WEBPACK FOOTER //
// ./src/env.js